import {
  bool,
  number,
  string,
  shape,
} from 'prop-types';

export const propTypes = {
  availableAt: string, // This is an optional secondary description
  category: string.isRequired,
  description: string.isRequired,
  equippable: bool, // is falsy by default
  effectiveLevel: number.isRequired,
  himbleLevel: number.isRequired,
  id: number.isRequired,
  image: string.isRequired,
  level: number.isRequired,
  nature: string.isRequired,
  name: string.isRequired,
  nameAndLevel: string.isRequired,
  progressAsPercentage: number.isRequired,
  relationshipDescription: string, // optional HTML string for certain contacts-type qualities
  qualityPossessedId: number.isRequired,
};

export default shape(propTypes);